const assessmentCheckpointType = Symbol();

export class AssessmentCheckpoint {
    [assessmentCheckpointType]: any;
    impairments: string[];
    activities: string[];
    participations: string[];
    environments: string[];
    personals: string[];

    constructor(
        impairments: string[],
        activities: string[],
        participations: string[],
        environments: string[],
        personals: string[],
    ) {
        this.impairments = impairments;
        this.activities = activities;
        this.participations = participations;
        this.environments = environments;
        this.personals = personals;
    }
}
